import { createContext } from "react";

export type AlertType = 'success' | 'warning' | 'error';

export interface AlertProps {
    type: AlertType;
    message: string;
    duration?: number;
}

export interface AlertServiceContextType {
    showAlert: (alert: AlertProps) => void;
}

export const AlertServiceContext = createContext<AlertServiceContextType | null>(null);